import React from 'react';
import styled from 'styled-components';
import Button from '@mui/material/Button';
import propTypes from 'prop-types';
import { StyledButton } from '../../../Components/Generics.styled';

const LeadGeneratorHomeContainer = styled.div`
    display: flex;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    flex-direction: column;
`;

const Title = styled.div`
    font-size: 23px;
    font-weight: bold;
    margin-top: 80px;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
`;

const LeadGeneratorContainer = styled.div`
    display: flex;
    margin-top: 50px;
    flex-direction: column;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
`;

const StepContainer = styled.div`
  display: flex;
  flex-direction: column
  width: 600px;
  margin-top: 12px;
`;

const StepSteps = styled.div`
    width: 100px;
    font-weight: bold;
    flex-direction: column;
`;
const StepsResponse = styled.div`
    width: 100%;
    margin-bottom: 5px;
    text-align: left;
`;

const StyledNavButtons = styled.div`
    display: flex;
    justify-content: space-evenly;
    height: 70px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 30px;
`;

const InstructionsBox = styled.div`
    padding: 16px;
    height: 180px;
    width: 100%;
    max-width: 600px;
    background-color: #2e69fe;
    border-radius: 25px;
    text-align: left;
    color: #fafbf7;
`;
const StepsOverviewContainer = styled.div`
    height: 100%;
    display: flex;
    flex-direction: row;
`;
const StepsCircle = styled.div`
    padding-top: 45px;
    margin-top: 100px;
    height: 150px;
    width: 150px;
    font-size: 40px;
    background-color: #2e69fe;
    border-radius: 50%;
    display: inline-block;
    color: #fafbf7;
`;
const LeadGeneratorHome = (props) => {
    const { handleNavButtonNext } = props;
    return (
        <LeadGeneratorHomeContainer>
            <Title>Create A Landing Page For Your Business</Title>

            <LeadGeneratorContainer>
                <InstructionsBox>
                    Lead Generation campaigns include a landing page (which can be imbedded in your
                    web site or published alone). Your page will have contact information and let
                    you add a few qualifying questions to make sure they are the best customers.
                    Then you can build one or more ad campaigns to attract customers to the page.
                    (We recommend at least one display campaign and one google campaign). Incoming
                    leads will come to you by email.
                </InstructionsBox>
                <br />
                <StepsOverviewContainer>
                    <StepsCircle>STEPS</StepsCircle>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <StepContainer>
                            <StepSteps>Step 1</StepSteps>
                            <StepsResponse>Create a Headline. </StepsResponse>
                        </StepContainer>
                        <StepContainer>
                            <StepSteps>Step 2</StepSteps>
                            <StepsResponse>Pick a primary color. </StepsResponse>
                        </StepContainer>
                        <StepContainer>
                            <StepSteps>Step 3</StepSteps>
                            <StepsResponse>Pick a secondary color. </StepsResponse>
                        </StepContainer>
                        <StepContainer>
                            <StepSteps>Step 4</StepSteps>
                            <StepsResponse>Upload a logo. </StepsResponse>
                        </StepContainer>
                        <StepContainer>
                            <StepSteps>Step 5</StepSteps>
                            <StepsResponse>Upload a background image. </StepsResponse>
                        </StepContainer>
                        <StepContainer>
                            <StepSteps>Step 6</StepSteps>
                            <StepsResponse>Select Your Questions.</StepsResponse>
                        </StepContainer>
                        <StepContainer>
                            <StepSteps>Step 7</StepSteps>
                            <StepsResponse>Choose an email to send your responses.</StepsResponse>
                        </StepContainer>
                        <StepSteps style={{ marginLeft: '75px', marginTop: '40px' }}>
                            Get Started!
                        </StepSteps>
                    </div>
                </StepsOverviewContainer>
            </LeadGeneratorContainer>
            <StyledNavButtons>
                <StyledButton
                    variant="contained"
                    color="primary"
                    onClick={() => handleNavButtonNext()}
                >
                    Next
                </StyledButton>
            </StyledNavButtons>
        </LeadGeneratorHomeContainer>
    );
};
LeadGeneratorHome.propTypes = {
    handleNavButtonNext: propTypes.func,
};

LeadGeneratorHome.defaultProps = {
    handleNavButtonNext: () => {},
};
export default LeadGeneratorHome;
